$(document).ready(function () {
  $("#newsletter-form").submit(function (event) {
    event.preventDefault();
    const email = $(event.target["email"]).val();
     if (!email) return;
    //Cosette Admin APP Proxy - apps/newsletter-subscribe - Path: Cosette Reviews App  
      $.post("apps/newsletter-subscribe", { email, country: Shopify.country }, function (data) {
      if (data.code == "success") {
        $("#ModalSubsribeGood").modal("show");
      } else if (data.code == "duplicate_parameter") {
        $("#ModalSubsribeBad").modal("show");
      }
    });
  });
});

